import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaCheck, FaExclamationTriangle } from 'react-icons/fa';
import Logo from '../components/common/Logo';
import Parse from '../config/parse';

const ResetPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Por favor ingresa tu correo electrónico');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      // Usar la API nativa de Parse para enviar el email de restablecimiento
      await Parse.User.requestPasswordReset(email);
      
      // Siempre mostramos éxito por razones de seguridad (no revelar si el email existe)
      setSuccess(true);
      setEmail('');
    } catch (error) {
      console.error('Error al solicitar restablecimiento de contraseña:', error);
      // No mostramos el error específico por seguridad
      // Solo registramos el error en la consola para depuración
      
      // Aún así mostramos éxito para no revelar si el email existe
      setSuccess(true);
      setEmail('');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5">
          <div className="card shadow">
            <div className="card-body p-5">
              <div className="text-center mb-4">
                <div className="d-inline-block mb-3">
                  <Logo size="medium" showText={false} />
                </div>
                <h2 className="fw-bold">Restablecer Contraseña</h2>
                <p className="text-muted">
                  Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña
                </p>
              </div>
              
              {error && (
                <div className="alert alert-danger d-flex align-items-center" role="alert">
                  <FaExclamationTriangle className="me-2" />
                  <div>{error}</div>
                </div>
              )}
              
              {success ? (
                <div className="alert alert-success d-flex align-items-center" role="alert">
                  <FaCheck className="me-2" />
                  <div>
                    <p className="mb-0">
                      Si el correo electrónico está asociado a una cuenta, recibirás un enlace para restablecer tu contraseña.
                    </p>
                    <p className="mb-0 mt-2">
                      Por favor revisa tu bandeja de entrada y sigue las instrucciones.
                    </p>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label htmlFor="email" className="form-label">
                      Correo Electrónico
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <FaEnvelope />
                      </span>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="correo@ejemplo.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={loading}
                        required
                      />
                    </div>
                  </div>
                  
                  <button
                    type="submit"
                    className="btn btn-primary w-100 py-2 mb-3"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Procesando...
                      </>
                    ) : (
                      <>
                        <FaCheck className="me-2" />
                        Enviar Enlace de Restablecimiento
                      </>
                    )}
                  </button>
                </form>
              )}
              
              <div className="text-center mt-3">
                <p className="mb-0">
                  <Link to="/login" className="text-decoration-none">
                    Volver a Iniciar Sesión
                  </Link>
                </p>
              </div>
            </div>
          </div>
          
          <div className="text-center mt-4">
            <Link to="/" className="text-decoration-none">
              &larr; Volver a la página principal
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
